import React, { useEffect } from 'react';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { AppShell } from './components/AppShell';
import { LibraryProvider } from './contexts/LibraryContext';
import { Home } from './pages/Home';
import { Search } from './pages/Search';
import { Favorites } from './pages/Favorites';
import { Library } from './pages/Library';
import { NumberDetail } from './pages/NumberDetail';
function ScrollToTop() {
  const {
    pathname,
    search
  } = useLocation();
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'auto'
    });
  }, [pathname, search]);
  return null;
}
function AnimatedRoutes() {
  const location = useLocation();
  return <AnimatePresence mode="wait" initial={false} data-id="element-0" data-mp="2wifgpfyzpczr">
      <Routes location={location} key={location.pathname} data-id="element-1" data-mp="28u5z6q8t7bef">
        <Route path="/" element={<Home data-id="element-3" data-mp="23vck4tdvjcc5" />} data-id="element-2" data-mp="28skzynbjv4a8" />
        <Route path="/search" element={<Search data-id="element-5" data-mp="23ujlygszdv5m" />} data-id="element-4" data-mp="23vupqgmff2wq" />
        <Route path="/favorites" element={<Favorites data-id="element-7" data-mp="3ik7g4ghnibqn" />} data-id="element-6" data-mp="23v2uj6wqr76z" />
        <Route path="/explore" element={<Library data-id="element-9" data-mp="3ijpbowku4r7n" />} data-id="element-8" data-mp="3ikqwvtvkeu33" />
        <Route path="/number/:id" element={<NumberDetail data-id="element-11" data-mp="3ml17jjuay8oa" />} data-id="element-10" data-mp="3ii4ro0w5cqo1" />
        <Route path="*" element={<Home data-id="element-13" data-mp="3mjga9mglsbmq" />} data-id="element-12" data-mp="3mk83iqmq9x9u" />
      </Routes>
    </AnimatePresence>;
}
export function App() {
  return <LibraryProvider data-id="element-14" data-mp="3recdzjv7cnfo">
      <BrowserRouter data-id="element-15" data-mp="5yhupa6n3cr">
        <ScrollToTop data-id="element-16" data-mp="67z9oh5w26u" />
        <AppShell data-id="element-17" data-mp="4n5w26l2pak">
          <AnimatedRoutes data-id="element-18" data-mp="56m9egl55mh" />
        </AppShell>
      </BrowserRouter>
    </LibraryProvider>;
}